import * as t from "react";
import r from "../lib/IconBase.es.js";
import a from "../defs/ListBullets.es.js";
const e = t.forwardRef((o, s) => /* @__PURE__ */ t.createElement(r, { ref: s, ...o, weights: a }));
e.displayName = "ListBulletsIcon";
const m = e;
export {
  m as ListBullets,
  e as ListBulletsIcon
};
